import CampaignMappingTool from "./CampaignMappingTool";

export default CampaignMappingTool;
